import { MutationTree } from 'vuex';
import { ConfigState } from './types';
import { save } from '@/helpers/storage';
import { event } from 'vue-analytics';

const mutations: MutationTree<ConfigState> = {

};

export default mutations;
